 export const slugLabels = {
    0: 1445,
    1: 382,
    2: 383,
    3: 589,
    4: 68,
    5: 69,
    6:590,
    7: 71,
    8: 591,
    9:592,
    10: 74,
    11: 75,
    12: 76,
    13:77
  };